import React, { FunctionComponent, useState } from 'react';

import { IStreamEvent } from 'interfaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup, Tooltip } from '@cfa/react-components';
import { faChevronDown, faChevronRight, faCopy } from '@fortawesome/free-solid-svg-icons';
import toast from 'react-hot-toast';

interface IStreamEventItemProps {
    event: IStreamEvent,
}

export const StreamEventItem: FunctionComponent<IStreamEventItemProps> = ({ event }) => {

    const [expanded, setExpanded] = useState(false);
    const toggleOpen = () => {
        setExpanded(!expanded);
    }

    const copyToClipboard = () => {
        navigator.clipboard.writeText(JSON.stringify(parsedMessage, null, 2));
        toast.success("Message copied");
    }

    const parsedMessage = JSON.parse(event.payload);

    return (<>
        <div className="messageEvent">
            
            <div className="messageEvent_flexContainer">
                <span className="messageEvent_flexLabel messageEvent_messageEventLabel">
                    {parsedMessage.event || "Message"} from {parsedMessage.serialNumber || "[missing serialNumber]"}
                </span>
                <ButtonGroup size='sm'>
                    <Tooltip content="Copy" showOnElementDelay={{showDelay: 1000}}>
                        <Button color='secondary' onClick={copyToClipboard} className='itemTable_iconButton'>
                            <FontAwesomeIcon icon={faCopy} />
                        </Button>
                    </Tooltip>
                    <Tooltip content="Expand" showOnElementDelay={{showDelay: 1000}}>
                        <Button onClick={toggleOpen} className='itemTable_iconButton'>
                            {!expanded && (<FontAwesomeIcon icon={faChevronRight} />)}
                            {expanded && (<FontAwesomeIcon icon={faChevronDown} />)}
                        </Button>
                    </Tooltip>
                </ButtonGroup>
            </div>
            {expanded && (
                <div className="messageEvent_json">
                    <pre>
                        {event.topic} <br/>
                        {JSON.stringify(parsedMessage, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    </>);
}